import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components';

class TVLayout extends Component {
  componentDidMount() {
    const {title} = this.props;
    document.title = `MAM: ${title}`;
    document.body.className += ' status-dashboard-layout';
  }

  render() {
    const {className, user} = this.props;
    return (
      <div className={className}>
        {!user.isLogin ? null : (
          <TVLayoutStyled>
            {this.props.children}
          </TVLayoutStyled>
        )}
      </div>
    );
  }
}

const TVLayoutStyled = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

TVLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  className: PropTypes.string,
  user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default connect(mapStateToProps)(withRouter(TVLayout));
